import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { postFiltrarCidade, getCidades, } from "../../services/apiCidade";
import { Helmet } from "react-helmet";
import Filtro from "../../components/filtro";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { faEye, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./index.css";
import Paginacao from "../../shared/paginacao";
import { erroToastify, sucessoToastify } from "../../shared/validacaoToastify";
import TabelaConsulta from "../../components/tabelaConsulta/tabelaConsulta";
import SelectGenerico from "../../components/selectGenerico/selectGenerico";

interface Cidade {
  nmCidade: string;
  cdCidade: number;
  cdUf: number;
}

function ConsultaCidade() {
  const [ordem, setOrdem] = useState<string>("asc");
  const [cidadesFiltradas, setCidadesFiltradas] = useState<Cidade[]>([]);
  const [cidades, setCidades] = useState<Cidade[]>([]);
  const [totalRegistros, setTotalRegistros] = useState<number>(0);
  const [totalPaginas, setTotalPaginas] = useState<number>(0);
  const [paginaAtual, setPaginaAtual] = useState<number>(1);
  const [filtroAtivo, setFiltroAtivo] = useState<boolean>(false);
  const [filtroAplicado, setFiltroAplicado] = useState<{
    [key: string]: string;
  }>();
  const [radioValue, setRadioValue] = useState<number>(10);
  const location = useLocation();
  const navigate = useNavigate();
  const options = [
    { valor: 10, rotulo: "10" },
    { valor: 30, rotulo: "30" },
    { valor: 50, rotulo: "50" }
  ];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const successMessage = searchParams.get("successMessage");
    if (successMessage) {
      sucessoToastify(successMessage);
      navigate("/milshop/cidade/consultar");
    }
  }, [location.search, navigate]);


  const camposFiltro = [
    { label: "Cidade", campo: "nmCidade" },
    { label: "Sigla UF", campo: "nmSigla" },
  ];

  const alternarOrdem = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setOrdem(selectedValue);
    buscarDados(paginaAtual, radioValue, false, selectedValue);
  };

  const aplicarFiltro = async (filtro: { [key: string]: string }, novoFiltro: boolean) => {
    try {
      const response = await postFiltrarCidade(
        filtro,
        novoFiltro ? "1" : paginaAtual.toString(),
        radioValue.toString(),
        ordem
      );
      const cidadesFiltro = response.listaCidadesEncontradas;
      const contadorCidades = response.contadorCidades;
      setCidadesFiltradas(cidadesFiltro);
      setTotalRegistros(contadorCidades);
      setTotalPaginas(Math.ceil(contadorCidades / radioValue));
      setPaginaAtual(novoFiltro ? 1 : paginaAtual);
      setFiltroAtivo(true);
      setFiltroAplicado(filtro);
    } catch (error: any) {
      if (error.response){
        erroToastify(error.response.data);
      } else {
        console.error("Erro ao aplicar filtro:", error);
        erroToastify("Ocorreu um erro ao aplicar o filtro");
      }
    };
  }

  const contarTotalCidade = async () => {
    try {
      const response = await getCidades("1", "1", "asc");
      const contadorTotalCidades = response.contadorCidades;
      return contadorTotalCidades;
    } catch (error) {
      console.error("Erro ao chamar o contador:", error);
    }
  }

  const limparFiltro = async () => {
    try {
      setCidadesFiltradas([]);
      const totalCidades = await contarTotalCidade();
      setTotalRegistros(totalCidades);
      setPaginaAtual(1);
      setFiltroAtivo(false);
      setFiltroAplicado(undefined)
    } catch (error) {
      console.error("Erro ao limpar filtro:", error);
    }
  };

  const buscarDados = async (pagina: number, registrosPorPagina: number, novoFiltro: boolean, ordem: string) => {
    try {
      if (filtroAplicado) {
        aplicarFiltro(filtroAplicado, novoFiltro);
      } else {
        const responseCidades = await getCidades(pagina.toString(), registrosPorPagina.toString(), ordem);
        const cidadesData = responseCidades.listaCidade || [];
        const contadorCidades = responseCidades.contadorCidades || 0;
        setTotalRegistros(contadorCidades);
        setTotalPaginas(Math.ceil(contadorCidades / registrosPorPagina));
        setCidades(cidadesData);
        setPaginaAtual(pagina);
      }
    } catch (error) {
      console.error("Erro ao buscar cidades:", error);
    }
  };

  useEffect(() => {
    if (!filtroAtivo || radioValue !== 10) {
      buscarDados(paginaAtual, radioValue, false, ordem);
    } else {
      if (filtroAplicado) {
        aplicarFiltro(filtroAplicado, false).then(() => {
          setTotalPaginas(Math.ceil(totalRegistros / radioValue));
        });
      }
    }
  }, [paginaAtual, filtroAtivo, radioValue, filtroAplicado, ordem]);

  useEffect(() => {
    buscarDados(paginaAtual, radioValue, false, ordem);
  }, [paginaAtual, radioValue, filtroAplicado, ordem]);


  const alterarValorRadio = (value: number) => {
    setRadioValue(value);
    setPaginaAtual(1);
    buscarDados(1, value, true, ordem);
  };

  const aplicarFiltroWrapper = (filtro: { [key: string]: string }) => {
    aplicarFiltro(filtro, true);
  };

  const trocarPagina = (pageNumber: number) => {
    setPaginaAtual(pageNumber);
  };

  return (
    <>
      <Helmet>
        <title>Consulta cidade</title>
      </Helmet>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <Filtro
          campo={camposFiltro}
          onFiltrar={aplicarFiltroWrapper}
          limparFiltro={limparFiltro}
        />
        <div className="d-flex justify-content-between w-75">
          <div className="d-flex align-items-center">
            <p className="ms-25 m-0 text-center me-2">Ordenar:</p>
            <div className="col-auto">
              <select
                className="form-select filtro-select"
                aria-label="Small select example"
                onChange={(e) => alternarOrdem(e)}
              >
                <option value="asc">A-Z</option>
                <option value="desc">Z-A</option>
              </select>
            </div>
          </div>

          <div className="d-flex align-items-center me-2 mb-2">
            <p className="ms-25 m-0 text-center me-2">Registros por página:</p>
            <SelectGenerico
              opcoes={options}
              valorSelecionado={radioValue}
              onChange={(value) => alterarValorRadio(Number(value))}
              opcaoPadrao="Selecione"
              classe="form-select filtro-select selectRegistroPagina"
              temLabel={false}
            />
          </div>
          
        </div>

        <div className="w-75">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="ms-25 m-0 text-center">
              {totalRegistros} resultados, Página {paginaAtual}
            </p>

            <button
              type="button"
              role="button"
              style={{ width: "100px" }}
              className="btn btn-outline-primary me-2 btn-sm custom-btn"
              onClick={() => navigate("/cidade/incluir")}
            >
              Incluir
            </button>
          </div>
          <div className="table-responsive">
            <TabelaConsulta
              dados={cidadesFiltradas && cidadesFiltradas.length > 0 ? cidadesFiltradas : cidades}
              colunas={[
                { chave: "nmCidade", titulo: "Cidade" },
                { chave: "nmSigla", titulo: "Sigla UF" }
              ]}
              cdEntidade={"cdCidade"}
              entidade="cidade"
            />
          </div>
          <Paginacao paginaAtual={paginaAtual} totalPaginas={totalPaginas} onPageChange={trocarPagina} />
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default ConsultaCidade;
